<template>
    <div>
        <el-col :span="avgSpans" class="form-title">
            <el-select v-model="placeholders.ProvinceName" :maxlength="200" filterable placeholder="省" v-on:change="onProvinceChange">
                <el-option v-for="item in provinces"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                           :disabled="disabled">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="avgSpans" class="form-title">
            <el-select v-model="placeholders.CityName" :maxlength="50" filterable placeholder="市" v-on:change="onCityChange" @visible-change="getCityList(placeholders.ProvinceID)">
                <el-option v-for="item in citys"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                           :disabled="disabled">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="avgSpans" class="form-title">
            <el-select v-model="placeholders.CountyName" :maxlength="50" filterable placeholder="区(县)" v-on:change="onCountyChange" @visible-change="getCountyList(placeholders.CityID)">
                <el-option v-for="item in countys"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                           :disabled="disabled">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="avgSpans" class="form-title" v-if="showTown">
            <el-input v-model.trim="placeholders.Town" placeholder="镇(街道)">
            </el-input>
        </el-col>
    </div>
</template>
<script>
    export default {
        name: "Distpicker",
        data() {
            return {
                provinces: [],
                totalcitys: [],
                totalcounty: [],
                citys: [],
                countys: [],
            }
        },
        props: {
            placeholders: {
                type: Object,
                default: {
                    NationCode: '',
                    ProvinceName: '',
                    ProvinceID: '',
                    CityName: '',
                    CityID: '',
                    CountyName: '',
                    CountyID: '',
                }
            },
            showTown: false,
            disabled: false,
        },
        computed:{
            avgSpans(){
                return this.showTown?6:8
            }
        },
        mounted() {
            this.geAreaList();
        },
        watch: {
            // 外部回填 ProvinceID/CityID 后（例如选中地址行、编辑订单回填），
            // 必须同步刷新市/区下拉的 options，否则旧 citys/countys 为空 → 下拉仍显示 placeholder
            'placeholders.ProvinceID': function () {
                this.getCityList(this.placeholders.ProvinceID);
            },
            'placeholders.CityID': function () {
                this.getCountyList(this.placeholders.CityID);
            },
        },
        methods: {
            onProvinceChange(val) {
                if (this.disabled) return;
                this.changeDataSource(1, val);
            },
            onCityChange(val) {
                if (this.disabled) return;
                this.changeDataSource(2, val);
            },
            onCountyChange(val) {
                if (this.disabled) return;
                this.changeDataSource(3, val);
            },
            getCityList(pCode) {
                if (!this.totalcitys) this.totalcitys = [];
                this.citys = this.totalcitys.filter(function (item) { return item.parentcode == pCode });
            },
            getCountyList(cCode) {
                if (!this.totalcounty) this.totalcounty = [];
                this.countys = this.totalcounty.filter(function (item) { return item.parentcode == cCode });;
            },
            getItemByName(arr, name) {
                var result = { name: '', code: '' };
                if (!arr || arr.length <= 0 || !name) return result;

                for (let i = 0; i < arr.length; i++) {
                    var row = arr[i];
                    if (row.value == name || row.value.indexOf(name) != -1) {
                        result.name = row.value;
                        result.code = row.code;
                        break;
                    }
                }
                return result;
            },
            geAreaList() {
                var _this = this;
                // 缓存必须是「完整的省列表数组」才算有效：
                // 历史上若缓存过旧结构（如 provinceList 小驼峰 / 空数组），
                // v-for 拿不到 option → 省/市/区三个下拉全是 placeholder，
                // 即使外面把 ProvinceName 赋进去也显示不出来，表现为「省市区带不出来、也不填充」。
                var arealist = localStorage.getItem('50omsarealist');
                var area = null;
                if (arealist) {
                    try {
                        area = JSON.parse(arealist);
                    } catch (e) {
                        area = null;
                    }
                }
                if (!area || !Array.isArray(area.ProvinceList) || area.ProvinceList.length === 0) {
                    localStorage.removeItem('50omsarealist');
                    this.loadAreaFromServer();
                    return;
                }
                this.applyArea(area);
            },
            loadAreaFromServer() {
                var _this = this;
                this.$ajax.send("omsapi/district/getaddressselectdata", "get", null, data => {
                    var area = data && data.Result;
                    if (!area || !Array.isArray(area.ProvinceList) || area.ProvinceList.length === 0) return;
                    localStorage.setItem('50omsarealist', JSON.stringify(area));
                    _this.applyArea(area);
                }, null, true);
            },
            applyArea(area) {
                this.provinces = Array.isArray(area.ProvinceList) ? area.ProvinceList : [];
                this.totalcitys = Array.isArray(area.CityList) ? area.CityList : [];
                this.totalcounty = Array.isArray(area.CountyList) ? area.CountyList : [];
                // 立刻按当前已回填的省/市 code 预填子级列表，
                // 否则首次渲染时市/区下拉 options 为空 → 即使值正确也显示 placeholder
                var ph = this.placeholders || {};
                this.getCityList(ph.ProvinceID);
                this.getCountyList(ph.CityID);
            },
            changeDataSource(type, value) {
                var ph = this.placeholders || {};
                switch (type) {
                    case 1:
                        var pcode = this.getItemByName(this.provinces, value);
                        if (pcode != null && pcode != undefined) {
                            this.getCityList(pcode.code);
                            ph.ProvinceName = pcode.name;
                            ph.ProvinceID = pcode.code;
                        }

                        var cityItem = this.getItemByName(this.citys, ph.CityName);
                        if (cityItem != null && cityItem != undefined) {
                            ph.CityName = cityItem.name;
                            ph.CityID = cityItem.code;
                            this.getCountyList(cityItem.code);
                        }

                        var countryItem = this.getItemByName(this.countys, ph.CountyName);
                        if (countryItem != null && countryItem != undefined) {
                            ph.CountyName = countryItem.name;
                            ph.CountyID = countryItem.code;
                        }

                        break;
                    case 2:
                        var city = this.getItemByName(this.citys, value);
                        if (city != null && city != undefined) {
                            this.getCountyList(city.code);
                            ph.CityName = city.name;
                            ph.CityID = city.code;
                            this.getCountyList(city.code);
                        }

                        var countryItem = this.getItemByName(this.countys, ph.CountyName);
                        if (countryItem != null && countryItem != undefined) {
                            ph.CountyName = countryItem.name;
                            ph.CountyID = countryItem.code;
                        }
                        break;
                    case 3:
                        var county = this.getItemByName(this.countys, value);
                        if (county != null && county != undefined) {
                            ph.CountyID = county.code;
                            ph.CountyName = county.name;
                        }
                        break;
                }
            }
        }
    }
</script>
<style>
</style>